import { AutocompletePrediction } from '@bridebook/web/app-shared/lib/search/types';
import { getCustomPredictionValues } from '@bridebook/web/app-shared/lib/search/utils/custom-autocomplete-predictions';
import { LocationPinIcon } from './icons';

interface Props {
  suggestion: AutocompletePrediction;
  onClick: (suggestion: AutocompletePrediction) => void;
}

export const LocationSuggestionRow = ({ suggestion, onClick }: Props) => {
  const [title, subtitle] = getCustomPredictionValues(suggestion);

  return (
    <div className="bsloc" data-name="suggestion-block" onClick={() => onClick(suggestion)}>
      <span className="bsloc-icon">
        <LocationPinIcon width={11} height={13.75} />
      </span>
      <div>
        {title && <span className="bsloc-title" dangerouslySetInnerHTML={{ __html: title }} />}
        {subtitle && <span className="bsloc-sub" dangerouslySetInnerHTML={{ __html: subtitle }} />}
      </div>
    </div>
  );
};
